import { Controller } from "@hotwired/stimulus"

const PROPERTY = "--pinned-banners-height"

// Publie la hauteur réelle du bloc de bandeaux épinglés en haut de page dans une
// variable CSS, sous laquelle les navs publiques viennent se coller
// (`sticky top-[var(--pinned-banners-height)]`).
//
// Sans ça, le décalage des navs est écrit en dur et ne vaut que pour le seul
// bandeau jeu responsable : dès que le bandeau d'installation Android se révèle,
// le bloc passe de 37 px à ~94 px et recouvre la nav épinglée, qui porte un
// z-index inférieur. La révélation ayant lieu à l'exécution et seulement sur
// Chrome Android, aucune valeur statique ne peut être juste pour tout le monde —
// et dans la WebView Hotwire Native, où aucun bandeau n'est rendu, le bloc
// mesure 0.
export default class extends Controller {
  connect() {
    // Un premier calcul même sans ResizeObserver : sur un navigateur qui ne
    // l'expose pas, la hauteur reste au moins juste au chargement.
    this.#publish()

    if (typeof ResizeObserver !== "function") return

    this.observer = new ResizeObserver(() => this.#publish())
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    this.observer = null
    // Turbo met la page en cache telle quelle : conserver une hauteur calculée
    // pour un bandeau qui ne sera peut-être pas révélé sur la page suivante
    // décalerait sa nav dans le vide. On rend la main au défaut CSS (37 px).
    document.documentElement.style.removeProperty(PROPERTY)
    this.lastHeight = null
  }

  #publish() {
    // Arrondi : `getBoundingClientRect` rend des sous-pixels, qui feraient
    // réécrire la variable à chaque frame de scroll sans rien changer à l'œil.
    const height = Math.round(this.element.getBoundingClientRect().height)
    if (height === this.lastHeight) return

    this.lastHeight = height
    document.documentElement.style.setProperty(PROPERTY, `${height}px`)
  }
}
